export default __webpack_public_path__ + "static/media/gallery_00.37f1aeb4.jpg";